import React from 'react';
import PartitionValuesDisplay from '../../Builder/Partition/PartitionValuesDisplay';
import * as BuilderInfoUI from '../BuilderInfoUI';
import { formatWordsFromUpperCase } from '../../../utils';
import InfoPopupHeaderSetting from './InfoPopupHeaderSetting';
import { QueryType } from '../../../utils/apollo/graphqlSchema';
import { assertNotNil } from '../../../utils/types';
import useAnalysisBuilderInfo from '../../../redux/selectorHooks/useAnalysisBuilderInfo';

interface IProps {
  analysisId: string;
}

export default ({ analysisId }: IProps) => {
  const analysisBuilderInfo = useAnalysisBuilderInfo(analysisId);
  assertNotNil(analysisBuilderInfo);
  const { query: builderInfo, queryType } = analysisBuilderInfo;

  return (
    <BuilderInfoUI.HeaderContainer>
      {builderInfo?.schema && (
        <InfoPopupHeaderSetting label={'Schema'} hideSeparator>
          {builderInfo.schema.name}
        </InfoPopupHeaderSetting>
      )}
      {'subject' in builderInfo &&
        builderInfo.subject &&
        queryType !== QueryType.Expression && (
          <InfoPopupHeaderSetting label={'Subject'}>
            {builderInfo.subject.name}
          </InfoPopupHeaderSetting>
        )}
      {'significanceSubject' in builderInfo &&
        builderInfo.significanceSubject && (
          <InfoPopupHeaderSetting label={'Subject'}>
            {builderInfo.significanceSubject.name}
          </InfoPopupHeaderSetting>
        )}
      {'samplePercentage' in builderInfo && builderInfo.samplePercentage && (
        <InfoPopupHeaderSetting label={'Sampling Rate'}>
          {builderInfo.samplePercentage + '%'}
        </InfoPopupHeaderSetting>
      )}
      {'attribution' in builderInfo && builderInfo.attribution && (
        <InfoPopupHeaderSetting label={'Attribution'}>
          {builderInfo.attribution.name}
        </InfoPopupHeaderSetting>
      )}
      {'groupby' in builderInfo && builderInfo.groupby && (
        <InfoPopupHeaderSetting label={'Groupby'}>
          {builderInfo.groupby.name}
        </InfoPopupHeaderSetting>
      )}
      {'view' in builderInfo && builderInfo.view && (
        <InfoPopupHeaderSetting label={'Mode'}>
          {builderInfo.view.name}
        </InfoPopupHeaderSetting>
      )}
      {'partitions' in builderInfo && builderInfo.partitions && (
        <InfoPopupHeaderSetting label={'Partition'}>
          <PartitionValuesDisplay partitionValues={builderInfo.partitions} />
        </InfoPopupHeaderSetting>
      )}
      {'mode' in builderInfo && builderInfo.mode && (
        <InfoPopupHeaderSetting label={'Mode'}>
          {builderInfo.mode.name}
        </InfoPopupHeaderSetting>
      )}
      {'expressionMode' in builderInfo && builderInfo.expressionMode && (
        <InfoPopupHeaderSetting label={'Mode'}>
          {builderInfo.expressionMode.name}
        </InfoPopupHeaderSetting>
      )}
      {'pathMode' in builderInfo && builderInfo.pathMode && (
        <InfoPopupHeaderSetting label={'Mode'}>
          {builderInfo.pathMode.name}
        </InfoPopupHeaderSetting>
      )}
      {'significanceMode' in builderInfo && builderInfo.significanceMode && (
        <InfoPopupHeaderSetting label={'Mode'}>
          {builderInfo.significanceMode.name}
        </InfoPopupHeaderSetting>
      )}
      {'order' in builderInfo && builderInfo.order && (
        <InfoPopupHeaderSetting label={'Order'}>
          {formatWordsFromUpperCase(builderInfo.order.name)}
        </InfoPopupHeaderSetting>
      )}
    </BuilderInfoUI.HeaderContainer>
  );
};
